var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"car",staticClass:"car"},[_c('img',{attrs:{"src":require("../../../assets/MyProgress/car.png"),"alt":"car"}}),_vm._v(" "),_c('img',{staticClass:"smoke",attrs:{"src":require("../../../assets/MyProgress/smoke.png"),"alt":"smoke"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d543312","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/components/MyProgress/Daccord/Car.vue
// module id = 877
// module chunks = 1